import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Store from 'redux/Store'
import { getAllCustomData } from 'shared/components/App/Auth'
import { setCustomData } from 'shared/redux/actions'
import processFilterRoleChange from '../utils/processFilterRoleChange'
import { setFilterRoleName } from 'redux/actions'

interface useInitFilterRoleChangeProps {
  currentFilterRole: any
  initialRender: boolean
  dataLoaded: boolean
  setInitialRender: Function
  handleFilterRoleChanged?: Function
}

const useFilterRoleChange = (props: useInitFilterRoleChangeProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!props.initialRender && props.dataLoaded) {
      processFilterRoleChange({
        filter_role_id: props.currentFilterRole?.id,
        setShowOverlay: (data) => {},
      }).then((data: any) => {
        const allCustomData = getAllCustomData()
        allCustomData.filterRole = props.currentFilterRole
        Store.dispatch(setCustomData(allCustomData))
        Store.dispatch(setFilterRoleName(allCustomData.filterRole.name))

        if (props.handleFilterRoleChanged !== undefined) {
          props.handleFilterRoleChanged(props.currentFilterRole)
        }

        Store.dispatch(setFilterRoleName(props.currentFilterRole.name))
      })
    } else {
      props.setInitialRender(false)
    }
  }, [props.currentFilterRole])
}

export default useFilterRoleChange
